export default __webpack_public_path__ + "static/media/IMPORTANCE OF HOLD HAND RAILS IN STAIR CASE SIMULATOR.70afef36.JPG";